import { Injectable } from '@angular/core';
import { LocalFileNamespace } from 'datasource-service-lib';
import { IIconService } from 'interfaces-lib';

@Injectable({ providedIn: 'root' })
export class UtilityIconService implements IIconService {
  getIcon(type: string): string {
    type = type?.toLowerCase();
    switch (type) {
      case LocalFileNamespace.name.toLowerCase():
        return 'file_upload';
      default:
        return '';
    }
  }
}
